import React from 'react';
// Table: Word dokumanindaki veri sorumlusu / veri kategorileri / amac / hukuki sebep / basvuru tablolari icin
import { Container, Row, Col, Table } from 'react-bootstrap';
import {
    FaShieldAlt, FaUserCheck, FaInfoCircle,
    FaBuilding, FaListAlt, FaBullseye, FaGavel, FaShareAlt, FaLock
} from 'react-icons/fa';

const KVKKForm = () => {
    return (
        <div className="kvkk-page">
            {/* Header Section */}
            <section className="py-5">
                <Container>
                    <div className="text-center mb-5">
                        <div className="d-flex justify-content-center align-items-center mb-4">
                            <FaShieldAlt className="me-3" style={{ fontSize: '3rem', color: 'var(--black)' }} />
                            <h1 className="section-title mb-0">KVKK Aydınlatma Metni</h1>
                        </div>
                        <p className="lead">Kişisel Verilerin Korunması Kanunu kapsamında bilgilendirme</p>
                    </div>
                </Container>
            </section>

            {/* Content Section */}
            <section className="py-5 bg-light">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={10}>

                            {/* 1 - Giriş */}
                            <div className="modern-faq-item mb-4">
                                <div className="d-flex align-items-start">
                                    <div className="advantage-icon-modern me-3">
                                        <FaInfoCircle />
                                    </div>
                                    <div>
                                        <h3 className="modern-faq-question">Değerli Müşterimiz</h3>
                                        <p className="modern-faq-answer mb-3">
                                            Kişisel Verilerin Korunması Kanunu (“KVKK” veya “Kanun”) kapsamında Prime Motorlu Araçlar Anonim
                                            Şirketi (“Şirket”) veri sorumlusu sıfatına sahip olup, bu sıfatın gerektirdiği yükümlülüklerinin
                                            temini amacıyla KVKK’nın 10. maddesi ile Aydınlatma Yükümlülüğünün Yerine Getirilmesinde Uyulacak
                                            Usul ve Esaslar Hakkında Tebliğ çerçevesinde sizleri bilgilendirmektedir.
                                        </p>
                                        <p className="modern-faq-answer mb-3">
                                            Kişisel Veri, kişilerin kimliğine ait adı, soyadı, TC kimlik numarası başta olmak üzere adres ve
                                            telefon bilgileri, mesleki deneyim bilgileri, eğitim bilgileri, yabancı dil bilgileri gibi gerçek kişi
                                            ile ilişkilendirilebilir nitelikteki her türlü bilgiyi ifade etmektedir. Kişisel verinin özel bir türü
                                            olan Özel Nitelikli Kişisel Veriler ise; ırk, etnik köken, siyasi düşünce, felsefi inanç, din, mezhep
                                            veya diğer inançlar, kılık ve kıyafet, dernek, vakıf ya da sendika üyeliği, sağlık, cinsel hayat, ceza
                                            mahkûmiyeti ve güvenlik tedbirleriyle ilgili veriler ile biyometrik ve genetik verileri ifade etmektedir.
                                        </p>
                                        <p className="modern-faq-answer mb-3">
                                            Kişisel verileriniz öncelikle satış, rezervasyon ve kiralama teklif süreçlerinin yürütülmesi, kimlik
                                            doğrulamasının yapılması, ödeme işlemlerinin gerçekleştirilmesi, teslimat ve iade süreçlerinin
                                            tamamlanması, sigorta işlemlerinin yürütülmesi ve hasar ile rücu süreçleri başta olmak üzere satış
                                            sonrası destek faaliyetlerinin sürdürülmesi amacıyla işlenmektedir. Bu kapsamda ihtiyaç halinde müşteri
                                            hesabınızın oluşturulması ve kullanıma açılması, müşteri ilişkileri yönetiminin sağlanması, iş ortakları
                                            ve/veya tedarikçilerle sürdürülen ilişkilerin yürütülmesi, talep ve şikâyetlerin incelenmesi ile
                                            kiralama ve/veya satış sürecine dair tarafınıza gerekli bilgilendirmelerin yapılması da bu amaçlar
                                            arasındadır.
                                        </p>
                                        <p className="modern-faq-answer mb-3">
                                            Diğer yandan kişisel verileriniz hukuki süreçlerin takibi ve yürütülmesi, mevzuat gereğince yetkili
                                            resmi kurum ve kuruluşlarla bilgi paylaşımının sağlanması, veri güvenliğinin temini ve internet erişim
                                            kayıtlarının mevzuata uygun biçimde saklanması amaçlarıyla da işlenmektedir.
                                        </p>
                                        <p className="modern-faq-answer mb-3">
                                            Bunlara ek olarak ihtiyaç halinde çağrı merkezi hizmetleri kapsamında görüşme kaydı alınması,
                                            müşterilerin Findeks bilgilerinin talep edilmesi, finansal geçmişin sorgulanması ve ödeme kapasitesinin
                                            değerlendirilmesi, araç koruma hizmetlerinin sunulması, risk yönetimi süreçlerinin planlanması ve
                                            uygulanması, şirket faaliyetlerine yönelik denetim ve kontrol mekanizmalarının işletilmesi, raporlama ve
                                            inceleme çalışmalarının yürütülmesi ile internet sitesinin işlevselliğinin sağlanması da kişisel
                                            verilerinizin işlenme amaçları kapsamındadır.
                                        </p>
                                        <p className="modern-faq-answer mb-3">
                                            Son olarak kişisel verileriniz ürün ve hizmetlerimize dair pazarlama faaliyetleri çerçevesinde sizinle
                                            iletişime geçilmesi, ticari elektronik ileti gönderilmesi, kişiselleştirilmiş tekliflerin sunulması,
                                            memnuniyet anketleri ile analiz çalışmalarının gerçekleştirilmesi, ürün ve/veya hizmetlere yönelik
                                            bağlılık programlarının planlanması ve yürütülmesi, çerez uygulamaları aracılığıyla ilgili müşterilere
                                            özel pazarlama faaliyetlerinin sürdürülmesi işlemlerinin gerçekleştirilmesi amaçlarıyla da işlenmektedir.
                                        </p>
                                        <p className="modern-faq-answer">
                                            Şirketimiz tarafından yukarıda belirtilenler ile satış ve/veya kiralama süreçlerinin yürütülmesi ve
                                            ilgili mevzuattan doğan yükümlülüklerin yerine getirilmesi için gerekli olan kişisel verileriniz dışında
                                            herhangi bir kişisel verinizin KVKK'nın temel ilkeleri uyarınca toplanmaması esastır. Bu nedenle araç
                                            satış ve/veya kiralaması kapsamında Şirketimizle paylaşacağınız belge ve bilgilerde işlem için gerekli
                                            olanın dışında kişisel veri, özellikle de özel nitelikli kişisel veri paylaşılmamasını öneririz.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* 2 - Veri Sorumlusu Kimliği */}
                            <div className="modern-faq-item mb-4">
                                <div className="d-flex align-items-start">
                                    <div className="advantage-icon-modern me-3">
                                        <FaBuilding />
                                    </div>
                                    <div className="flex-grow-1">
                                        <h3 className="modern-faq-question">Veri Sorumlusu Kimliği</h3>
                                        {/* Adres / MERSIS / Sicil: firma tarafindan doldurulacak */}
                                        <Table responsive bordered className="modern-faq-answer mb-0">
                                            <tbody>
                                                <tr>
                                                    <td style={{ width: '30%' }}><strong>Ticaret Unvanı</strong></td>
                                                    <td>Prime Motorlu Araçlar Anonim Şirketi</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Adres</strong></td>
                                                    <td>[●]</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>MERSİS No</strong></td>
                                                    <td>[●]</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Sicil No</strong></td>
                                                    <td>[●]</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </div>

                            {/* 3 - İşlenen Kişisel Verileriniz */}
                            <div className="modern-faq-item mb-4">
                                <div className="d-flex align-items-start">
                                    <div className="advantage-icon-modern me-3">
                                        <FaListAlt />
                                    </div>
                                    <div className="flex-grow-1">
                                        <h3 className="modern-faq-question">İşlenen Kişisel Verileriniz</h3>
                                        <p className="modern-faq-answer mb-3">
                                            Şirket, Alıcı ile aranızda kurulacak ikinci el araç satış ve/veya kiralama sözleşmesinin görüşülmesi,
                                            kurulması ve ifası kapsamında aşağıda yer alan kişisel verileri işleyebilmektedir:
                                        </p>
                                        <Table responsive bordered className="modern-faq-answer mb-0">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: '30%' }}>İşlenen Veri Kategorisi</th>
                                                    <th>Açıklama</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td><strong>Kimlik Verisi</strong></td>
                                                    <td>Ad, soyad, T.C. kimlik numarası, doğum tarihi ve yeri, uyruk, imza bilgisi.</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>İletişim Verisi</strong></td>
                                                    <td>Telefon numarası, adres, e-posta adresi.</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Müşteri İşlem Verisi</strong></td>
                                                    <td>
                                                        Talep bilgisi, sipariş bilgisi, fatura bilgileri, sözleşme kayıtları, müşteri numarası ile
                                                        satış ve/veya kiralamaya konu aracın plaka, şasi no, motor no, model yılı, kilometre, ruhsat
                                                        ve ekspertiz raporu bilgileri dahil satış ve/veya kiralama sürecine ilişkin kayıtlar.
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Finans Verisi</strong></td>
                                                    <td>
                                                        Ödeme bilgileri, banka hesap ve IBAN bilgisi, fatura bilgileri, kredi veya finansman
                                                        kuruluşuyla yürütülen yazışmalara ilişkin bilgiler.
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Hukuki İşlem Verisi</strong></td>
                                                    <td>Sözleşme, noter işlemleri, devir ve tescil işlemlerine ilişkin belge ve yazışmalar.</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Görsel ve İşitsel Kayıt Verisi / Fiziksel Mekân Güvenliği Verisi</strong></td>
                                                    <td>
                                                        Şirket showroom ve satış ve/veya kiralama noktalarında kapalı devre kamera sistemiyle elde
                                                        edilen görüntü kayıtları.
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Diğer</strong></td>
                                                    <td>Satış ve/veya kiralama sonrası hizmet talepleri, şikâyet ve memnuniyet bilgileri.</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </div>

                            {/* 4 - İşlenme Amaçları */}
                            <div className="modern-faq-item mb-4">
                                <div className="d-flex align-items-start">
                                    <div className="advantage-icon-modern me-3">
                                        <FaBullseye />
                                    </div>
                                    <div className="flex-grow-1">
                                        <h3 className="modern-faq-question">Kişisel Verilerinizin İşlenme Amaçları</h3>
                                        <p className="modern-faq-answer mb-3">
                                            Şirket tarafından yukarıda belirtilen kişisel veriler, aşağıda sayılan amaçlar ve KVKK’nın öngördüğü
                                            hukuki sebepler kapsamında işlenebilmektedir:
                                        </p>
                                        <Table responsive bordered className="modern-faq-answer mb-0">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: '30%' }}>İşlenen Veri Kategorileri</th>
                                                    <th>Veri İşlemenin Amaçları</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td><strong>Kimlik, İletişim, Müşteri İşlem, Finans, Hukuki İşlem ve Fiziksel Mekân Güvenliği</strong></td>
                                                    <td>
                                                        Toplanan kişisel verileriniz ikinci el araç satış ve/veya kiralama sözleşmesinin görüşülmesi,
                                                        kurulması ve ifası, satış ve/veya kiralamaya konu aracın teslimi, devir ve tescil
                                                        işlemlerinin yürütülmesi, faturalandırma ve muhasebe kayıtlarının tutulması, vergi mevzuatı
                                                        ve Türk Ticaret Kanunu'ndan doğan yükümlülüklerin yerine getirilmesi, satış ve/veya kiralama
                                                        sonrası garanti ve destek hizmetlerinin sunulması, müşteri memnuniyetinin ölçülmesi, olası
                                                        uyuşmazlıkların çözümü ve hukuki taleplerin takibi ile Şirketin ticari ve iş stratejilerinin
                                                        belirlenmesi amaçlarıyla işlenmektedir. Şirket yerleşkelerinin fiziksel güvenliğinin
                                                        sağlanması amacıyla işlenmektedir.
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </div>

                            {/* 5 - Toplama Yöntemi ve Hukuki Sebebi */}
                            <div className="modern-faq-item mb-4">
                                <div className="d-flex align-items-start">
                                    <div className="advantage-icon-modern me-3">
                                        <FaGavel />
                                    </div>
                                    <div className="flex-grow-1">
                                        <h3 className="modern-faq-question">Kişisel Verilerin Toplama Yöntemi ve Hukuki Sebebi</h3>
                                        <p className="modern-faq-answer mb-3">
                                            Alıcıya ait kişisel veriler yukarıda yer alan amaçlarla satış ve/veya kiralama sözleşmesinin görüşülmesi
                                            ve imzalanması sürecinde Alıcı tarafından sözlü, yazılı veya elektronik ortamda iletilen bilgi ve
                                            belgeler yoluyla, araç teslim ve devir işlemleri sırasında noterlik ve ilgili tescil kuruluşlarıyla
                                            yapılan yazışmalar kapsamında, Şirket showroom ve satış ve/veya kiralama noktalarını ziyaretiniz halinde
                                            ise kapalı devre güvenlik kameraları aracılığıyla toplanmaktadır.
                                        </p>
                                        <p className="modern-faq-answer mb-3">
                                            Alıcıya ait kişisel veriler KVKK'nın 5. ve 6. madde hükümlerinde sayılan aşağıdaki hukuka uygunluk
                                            sebeplerine dayanılarak toplanmakta, saklanmakta ve işlenmektedir.
                                        </p>
                                        <Table responsive bordered className="modern-faq-answer mb-0">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: '30%' }}>İşlenen Veri Kategorileri</th>
                                                    <th>Veri İşlemenin Hukuki Sebepleri</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td><strong>Kimlik, İletişim, Müşteri İşlem, Finans, Hukuki İşlem</strong></td>
                                                    <td>
                                                        Bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya ilgili olması kaydıyla sözleşmenin
                                                        taraflarına ait kişisel verilerin işlenmesinin gerekli olması, Şirketin hukuki
                                                        yükümlülüğünü yerine getirebilmesi için veri işlemenin zorunlu olması, bir hakkın tesisi,
                                                        kullanılması veya korunması için veri işlemenin zorunlu olması ile ilgili kişinin temel hak
                                                        ve özgürlüklerine zarar vermemek kaydıyla Şirketin meşru menfaatleri için veri işlenmesinin
                                                        zorunlu olması hukuki sebeplerine dayanılarak işlenmektedir.
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Fiziksel Mekân Güvenliği</strong></td>
                                                    <td>
                                                        İlgili kişinin temel hak ve özgürlüklerine zarar vermemek kaydıyla Şirketin meşru menfaati
                                                        gereği fiziksel mekân güvenliğinin sağlanması amacıyla işlenmektedir.
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </div>

                            {/* 6 - Aktarım */}
                            <div className="modern-faq-item mb-4">
                                <div className="d-flex align-items-start">
                                    <div className="advantage-icon-modern me-3">
                                        <FaShareAlt />
                                    </div>
                                    <div>
                                        <h3 className="modern-faq-question">İşlenen Kişisel Verilerin Aktarımı</h3>
                                        <p className="modern-faq-answer">
                                            Alıcı’ya ait işlenen kişisel veriler yukarıda belirtilen amaçlar doğrultusunda ve yalnızca bu amaçlarla
                                            sınırlı olmak üzere satış ve/veya kiralama sözleşmesinin ifası kapsamında işlem yürütülen noterlik,
                                            trafik tescil müdürlükleri ve ilgili kamu kurumlarına, aracın sigortalanması halinde sigorta
                                            şirketlerine, satış ve/veya kiralamanın krediyle finanse edilmesi halinde banka ve finansman
                                            kuruluşlarına, Şirketin destek hizmeti aldığı tedarikçi firmalar ile veri tabanı, yazılım ve sunucu
                                            hizmeti sağlayıcılarına aktarılabilmektedir. Bunların dışında Şirketin bilgi ve belge verme
                                            yükümlülüklerini yerine getirmesi amacıyla vergi daireleri, Mali Suçları Araştırma Kurulu ve diğer
                                            yetkili kamu kurum ve kuruluşlarıyla, olası bir hukuki ihtilaf, adli veya idari denetim hâllerinde
                                            savunma hakkının kullanılması amacıyla istenen bilgiler anılan kurum, kuruluş ve makamlara talep ile
                                            sınırlı olarak aktarılabilmektedir.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* 7 - Muhafaza */}
                            <div className="modern-faq-item mb-4">
                                <div className="d-flex align-items-start">
                                    <div className="advantage-icon-modern me-3">
                                        <FaLock />
                                    </div>
                                    <div>
                                        <h3 className="modern-faq-question">İşlenen Kişisel Verilerin Muhafazası</h3>
                                        <p className="modern-faq-answer mb-3">
                                            Şirket, Kanunda belirlenen ve işbu Aydınlatma Metninde ifade edilen şartlarda kişisel verilerin hukuka
                                            aykırı şekilde işlenmemesini, erişilmemesini ve muhafazasını sağlamak amacıyla uygun güvenlik düzeyini
                                            temin etmeye yönelik gerekli teknik ve idari tedbirleri almaktadır.
                                        </p>
                                        <p className="modern-faq-answer">
                                            Şirket, satış ve/veya kiralama sözleşmesinden doğan yükümlülüklerini yerine getirebilmesi için gerekli
                                            olan süre boyunca ve her hâlükârda Türk Ticaret Kanunu ile Vergi Usul Kanunu başta olmak üzere ilgili
                                            mevzuatta öngörülen saklama sürelerinin sonuna kadar kişisel verilerinizi muhafaza etmektedir. Bu
                                            sürelerin sona ermesi hâlinde kişisel veriler, Kişisel Verileri Saklama ve İmha Politikası uyarınca
                                            silinmekte, yok edilmekte veya anonim hâle getirilerek imha edilmektedir.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* 8 - İlgili Kişi Hakları ve Başvuru */}
                            <div className="modern-faq-item">
                                <div className="d-flex align-items-start">
                                    <div className="advantage-icon-modern me-3">
                                        <FaUserCheck />
                                    </div>
                                    <div className="flex-grow-1">
                                        <h3 className="modern-faq-question">Kişisel Verisi İşlenen İlgili Kişi Hakları</h3>
                                        <p className="modern-faq-answer mb-3">
                                            Kişisel verisi işlenen Alıcılara KVKK'nın 11. maddesinde sayılan haklar tanınmıştır. Söz konusu hakların
                                            KVKK'nın 13. maddesine ve Veri Sorumlusuna Başvuru Usul ve Esasları Hakkında Tebliğe uygun olarak
                                            kullanılması gerekmektedir. Başvuru yönteminize göre aşağıda yer alan posta, elektronik posta veya
                                            kayıtlı elektronik posta (KEP) adreslerine başvurunuzu iletebilirsiniz. Başvuru formunun gönderilmesi
                                            sırasında zarf üzerine veya gönderilecek e-postanın konu kısmına “Kişisel Verilerin Korunması Kanunu
                                            Kapsamında Bilgi Talebi” yazılması rica olunur.
                                        </p>
                                        {/* Adres / KEP / e-posta: firma tarafindan doldurulacak */}
                                        <Table responsive bordered className="modern-faq-answer mb-3">
                                            <tbody>
                                                <tr>
                                                    <td style={{ width: '30%' }}><strong>Yazılı başvuru ile</strong></td>
                                                    <td>
                                                        Kimliğinizi doğrulamak kaydıyla Şirketimize iletebilir veya noter aracılığıyla
                                                        gönderebilirsiniz. [●]
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td><strong>KEP ile</strong></td>
                                                    <td>[●]</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>E-posta ile</strong></td>
                                                    <td>[●]</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                        <p className="modern-faq-answer mb-0">
                                            Başvurular mümkün olan en kısa sürede ve talebin niteliğine göre talebin Şirket’e ulaştığı tarihten
                                            itibaren en geç 30 gün içerisinde yanıtlandırılır.
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    );
};

export default KVKKForm;